import React from "react";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled, SxProps } from "@mui/material";

interface HtmlTooltipProps {
    tooltipSx: SxProps;
}

export const HtmlTooltip = styled(
    ({ className, ...props }: HtmlTooltipProps & TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    )
)(({ tooltipSx }) => ({
    [`& .${tooltipClasses.tooltip}`]: tooltipSx,
}));
